import { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';

import District from '../../sections/landing/district/District';
import SingleDistrictChurchList from '../../sections/landing/church/SingleDistrictChurchList';
import { Footer } from '../../sections/landing/footer';

export default function DistrictList() {
  const [selectedDistrict, setSelectedDistrict] = useState();
  const [show, setShow] = useState('district');
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, []);

  return (
    <div ref={containerRef}>
      <Helmet>
        <title> መነሻ | የሰ/ሸ/ሃ/መ/አ/ስርዓት </title>
      </Helmet>

      {show && show === 'district' && <District containerRef={containerRef} setSelectedDistrict={setSelectedDistrict} setShow={setShow} />}

      {show && show === 'church' && <SingleDistrictChurchList selectedDistrict={selectedDistrict} setShow={setShow} />}
      <Footer containerRef={containerRef} />
    </div>
  );
}
